import { DATE_FORMAT_DATE, DATE_FORMAT_ISO } from "../date-base/constants";

export const DEFAULT_CLIENT_DATE_FORMAT = DATE_FORMAT_DATE;
export const DEFAULT_DISPLAY_DATE_FORMAT = "yyyy-MM-dd HH:mm";
export const DEFAULT_SERVER_DATE_FORMAT = DATE_FORMAT_ISO;
